export enum DocumentModalSteps {
  DocumentList = 'document_list',
  DocumentDetails = 'document_details',
  MFA = 'mfa',
  Terms = 'terms',
  Success = 'success',
  Rejection = 'rejection'
}
